import { Calendar } from 'primereact/calendar'
import { InputText } from 'primereact/inputtext'
import { InputNumber } from 'primereact/inputnumber'
import React, { useCallback, useState } from 'react'
import { HorseRegisterDto, Horse, HorseRegisterApi } from '../../../api'
import { useLocalState } from '../../../shared/UseLocalState'
import { appState } from '../../../state/App.state'
import { authState } from '../../../state/Auth.state'
import { horsesState } from '../../../state/Horses.state'
import { Button } from 'primereact/button'
import { Loading } from '../../loading/Loading'
//import { useLocalState } from '../../../shared/UseLocalState'
//import { Horse } from '../../../api'
//import { horsesState } from '../../../state/Horses.state'

const NULL_DATE = new Date('1800-01-01')
const EMPTY_HORSE_REGISTER: HorseRegisterDto = {
  name: '',
  breed: '',
  color: '',
  gender: '',
  father: '',
  mother: '',
  birthday: NULL_DATE,
  owner: '',
  remark: '',
  stockSize: undefined,
  lifeNumber: ''
}

//if (!bookerId) throw new Error(`booker id is mandatory`)

export const Horses = () => {
  /* STATE */
  const bookerId = authState.user$.value?.registerId
  const bookerEmail = authState.user$.value?.email
  const horses = useLocalState<Horse[]>(horsesState.horses$, horsesState.horses$.value)

  const [loading, setLoading] = useState<boolean>(false)
  //    const [form] = useState<HorseRegisterDto>(EMPTY_HORSE_REGISTER)
  const [form, setForm] = useState<HorseRegisterDto>(EMPTY_HORSE_REGISTER)

  //const [form] = useState<HorseRegisterDto>(EMPTY_HORSE_REGISTER)

  /* LOGIC */
  const register = useCallback(() => {
    setLoading(true)
    if (bookerId == null) {
      setLoading(false)
    }
    form.bookerId = bookerId
    form.bookerEmail = bookerEmail

    new HorseRegisterApi(authState.apicfg())
      .apiHorseRegisterPostRaw({
        horseRegisterDto: form
      })
      .then(() => {
        appState.addToast('Registrierung erfolgreich!', 'success')
        //setForm(EMPTY_HORSE_REGISTER)
        //setForm(true)
      })
      .catch((err) => {
        appState.addToast('Registrierung fehlgeschlagen! Pr�fen Sie bitte die Felder', 'error')
        console.error(err)
      })
      .finally(() => setLoading(false))
  }, [form])

  /* TEMPLATE */
  return (
    <>
      <Loading loading={loading} />
      <div className='card' style={{ maxWidth: '600px', margin: '1rem auto', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h2 style={{ marginBottom: '0.25rem' }}>Neues Pferd registrieren</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            register()
          }}
          style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
        >
          {/* Name & Rasse */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <InputText
              style={{ flex: 1 }}
              placeholder='Name *'
              value={form.name ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, name: e.target.value ?? '' }))}
            />
            <InputText
              style={{ flex: 1 }}
              placeholder='Rasse'
              value={form.breed ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, breed: e.target.value ?? '' }))}
            />
          </div>
          {/* Farbe & Besitzer */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <InputText
              style={{ flex: 1 }}
              placeholder='Farbe'
              value={form.color ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, color: e.target.value ?? '' }))}
            />
            <InputText
              style={{ flex: 1 }}
              placeholder='Besitzer'
              value={form.owner ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, owner: e.target.value ?? '' }))}
            />
          </div>
          {/* Geschlecht */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <InputText
              style={{ flex: 1 }}
              placeholder='Geschlecht'
              value={form.gender ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, gender: e.target.value ?? '' }))}
            />
          </div>
          {/* Mutter & Vater */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <InputText
              style={{ flex: 1 }}
              placeholder='Mutter'
              value={form.mother ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, mother: e.target.value ?? '' }))}
            />
            <InputText
              style={{ flex: 1 }}
              placeholder='Vater'
              value={form.father ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, father: e.target.value ?? '' }))}
            />
          </div>
          {/* Geburtstag */}
          <Calendar
            style={{ width: '100%' }}
            placeholder='Geburtstag'
            value={(form?.birthday ?? new Date(0)) > new Date(0) ? form.birthday : null}
            dateFormat='dd.mm.yy'
            onChange={(e) => setForm((v) => ({ ...v, birthday: e.value ?? new Date(0) }))}
            showIcon
          />
          {/* Stockmaß & Lebensnummer */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
            <InputNumber
              style={{ flex: 1 }}
              placeholder='Stockmaß (cm)'
              value={form.stockSize ?? null}
              onValueChange={(e) => setForm((v) => ({ ...v, stockSize: e.value ?? undefined }))}
              min={0}
              max={300}
              maxFractionDigits={0}
              suffix=' cm'
            />
            <InputText
              style={{ flex: 1 }}
              placeholder='Lebensnummer'
              value={form.lifeNumber ?? ''}
              onChange={(e) => setForm((v) => ({ ...v, lifeNumber: e.target.value ?? '' }))}
            />
          </div>
          {/* Anmerkung */}
          <InputText
            style={{ width: '100%' }}
            placeholder='Anmerkung'
            value={form.remark ?? ''}
            onChange={(e) => setForm((v) => ({ ...v, remark: e.target.value ?? '' }))}
          />
        </form>
        <Button onClick={register} disabled={!form.name || form.name.length < 1}>
          Registrieren
        </Button>
        <Button outlined onClick={() => window.history.back()}>
          Zurück
        </Button>
      </div>
    </>
  )
}
